import axios from "axios";
import { AdminBaseUrl, AdminBaseUrl1 } from "../../Basurl/Baseurl";
import { saveCrmRequest } from "../../services/crmRequestSaveApi";

const unwrapList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data?.tests)) return payload.data.tests;
  if (Array.isArray(payload?.data?.test_list)) return payload.data.test_list;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.tests)) return payload.tests;
  if (Array.isArray(payload?.test_list)) return payload.test_list;
  return [];
};

export const fetchGeneralEnquiry = async (id, model) => {
  const response = await axios.post(`${AdminBaseUrl}other_enquiry_details`, {
    id,
    type: model,
  });
  return response.data;
};

export const fetchHomeCareTypes = async () => {
  const response = await axios.get(`${AdminBaseUrl}home-care-types`, {
    headers: { Accept: "application/json" },
  });
  return unwrapList(response.data);
};

export const fetchHomeCareServices = async (homeCareTypeId) => {
  const response = await axios.get(`${AdminBaseUrl}home-care-services`, {
    params: { home_care_type_id: homeCareTypeId },
    headers: { Accept: "application/json" },
  });
  return unwrapList(response.data);
};

export const fetchTestList = async () => {
  const response = await axios.post(
    `${AdminBaseUrl1}test_list`,
    {},
    { headers: { Accept: "application/json" } },
  );
  return unwrapList(response.data);
};

const toInt = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};

const optionalText = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

export const buildHomeCareSavePayload = (values = {}, recordId) => {
  const payload = {
    user_id: toInt(values.user_id),
    home_care_type_id: toInt(values.home_care_type_id),
    country_id: toInt(values.country_id),
    state_id: toInt(values.state_id),
    city_id: toInt(values.city_id),
    address: optionalText(values.address),
    start_date: optionalText(values.start_date),
    end_date: optionalText(values.end_date),
    term_condition: values.term_condition ? "1" : "0",
  };

  if (recordId) payload.id = toInt(recordId);

  [
    "name",
    "email",
    "country_code",
    "phone",
    "passport_number",
    "pin_code",
    "location_pin",
    "contact_number",
    "emergency_contact_number",
  ].forEach((key) => {
    const text = optionalText(values[key]);
    if (text) payload[key] = text;
  });

  return payload;
};

export const saveGeneralEnquiry = async (body, savePath) => {
  return saveCrmRequest(savePath, body);
};
